import { SpinnerPage } from '@csp/csp-web-ui';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getUserSelector } from '../../security/ducks/principalContextSelectors';
import { CloseoutTrackerModalComponent } from '../component/CloseoutTrackerModalComponent';

const CloseoutTrackerNotificationContainer: FC = () => {
  const user = useSelector(getUserSelector);

  if (!user) {
    return <SpinnerPage />;
  }

  return <CloseoutTrackerModalComponent user={user} />;
};

export default CloseoutTrackerNotificationContainer;
